import { Link } from "@tanstack/react-router";
import { AuthShell } from "../../components/auth/AuthShell";

/**
 * AUTH-01 — AMSaaS (B2B) **client** login: https://amsaas.app/login/client.
 *
 * Door for client users / client admins. They may belong to several providers,
 * so the copy hints at the post-login org switcher (OS-01). Neutral, app-branded
 * only (WL-03).
 */
export function AmsaasClientLoginPage(): JSX.Element {
  return (
    <AuthShell
      appName="AMSaaS"
      appTagline="Application Management Services as a Service"
      logoSrc="/logos/amsaas-login-banner.png"
      logoSrc2x="/logos/amsaas-login-banner@2x.png"
      accent="#2563eb"
      panelClassName="bg-gradient-to-br from-slate-950 via-slate-900 to-blue-950"
      audienceLabel="Client sign-in"
      headline="Run your service business on autopilot. Every client. Every service. One view."
      blurb="Sign in to manage application managed services, subscriptions, and billing for every client — all in one place, all self-service."
      quote={{
        text: "Subscriptions, billing and our support team in one place — our admin time dropped by half.",
        author: "Priya Nair, Head of IT Operations",
      }}
      footer={
        <p>
          Are you a provider?{" "}
          <Link
            to="/login/provider"
            className="font-medium text-foreground hover:underline"
          >
            Provider sign-in
          </Link>
        </p>
      }
    />
  );
}
